<template>

<app-page :loading="is.loading" :locked="is.saving || is.confirming">

	<app-page-head :title="title" :back="$route.meta.back">

		<template v-if="$permission('edit')">

			<app-page-head-action v-if="model.id && $permission('full')" :disabled="isDirty" :loading="is.copying" icon="copy" tooltip="Copy" v-on:click.native="onCopyClick" />
			<app-page-head-action :disabled="!isDirty" icon="undo" tooltip="Undo changes" v-on:click.native="onUndoClick" />
			<app-page-head-action :disabled="!isDirty || !isValid" :loading="is.saving" icon="save" tooltip="Save changes" v-on:click.native="onSaveClick" />
			<app-page-head-action v-if="!isNew && $canDelete" :loading="is.deleting" :disabled="isNew" :danger="true" icon="delete" tooltip="Delete" v-on:click.native="onDeleteClick" />

		</template>
		
	</app-page-head>

	<app-page-content :is-grown="true">

		<app-page-content-section :is-padded="true" :is-divided="true">

            <app-input-text v-model="model.name" maxlength="32" :validation="$v.model.name" label="Name" placeholder="Enter name" />

        </app-page-content-section>

		<app-page-content-section :is-padded="true">

			<app-input-section label="Sections" v-model="model.content" :is-admin="true" />

        </app-page-content-section>

		<app-page-content-section title="Groups using" v-if="!isNew && groupReferencesCount">

			<com-group :item="group" v-for="group in groupReferences" :key="group.id" />

		</app-page-content-section>

		<app-page-content-section title="Locations using" v-if="!isNew && locationReferencesCount">

			<com-location :item="location" v-for="location in locationReferences" :key="location.id" />

		</app-page-content-section>

	</app-page-content>

	<app-page-foot />

	<portal to="preview">

		<app-blocks :item="block" v-for="block in previewBlocks" :key="block.id" :is-rendered="true" />

	</portal>

	<div class="delete" v-if="is.deleting" :class="{'is-loading': is.confirming}">

		<app-icon icon="warning" class="delete-icon" />

		<div class="delete-title">Delete Template</div>

		<div class="delete-text">Are you sure you wish to delete the template <b>{{ model.name }}</b>? This cannot be reversed.</div>

		<div class="delete-buttons">

			<div class="delete-buttons-item is-danger" v-on:click="onConfirmDeleteClick">
				<template v-if="!is.confirming">Confirm</template>
				<app-icon icon="loading" v-if="is.confirming" />
			</div>

			<div class="delete-buttons-item" v-on:click="onCancelDeleteClick">Cancel</div>

		</div>

	</div>

</app-page>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	components: {
		'com-location': () => import('./locations/Item'),
		'com-group': () => import('./groups/Item')
	},
	
	data: function() {

		return {
			is: {
				copying: false,
				confirming: false,
			},
			model: {
				id: 0,
				name: '',
				content: []
			},
			param: 'template',
            noun: 'template'
		}

	},

	validations: function() {
		
        var validations = {
            model: {
                name: {
                    required,
                    maxLength: maxLength(32)
                }
            }
        }

        return validations 

	},

	computed: {

		groupReferences: function() {

			return this.$_.filter(this.$store.getters['groups'], function(item) {

				return item.template === this.model.id

			}.bind(this))

		},

		groupReferencesCount: function() {

			return this.groupReferences.length

		},

		locationReferences: function() {

			return this.$_.filter(this.$store.getters['locations'], function(item) {

				return item.template === this.model.id

			}.bind(this))

		},

		locationReferencesCount: function() {

			return this.locationReferences.length

		},

		previewBlocks: function() {

			var blocks = []

			this.$_.each(this.model.content, function(content) {

				if (content.enabled) {

					this.$_.each(content.blocks, function(block) {

						if(block.enabled) blocks.push(block)

					})

				}

			}.bind(this))

			return blocks

		},

		stashName: function() {

			return 'template/' + this.model.id

		}

	},

    methods: {

        load: function() {

			this.is.loading = true

			this.$api.get(['template', this.$route.params.template]).then(function(response) {

                this.$vueset(this, 'model', this.$util.clone(response.template))

				this.original = this.$util.clone(this.model)

				this.is.loading = false

			}.bind(this))

		},

        save: function() {

			this.is.saving = true

			this.$api[(this.$route.params.template === 'new') ? 'post' : 'put'](['template', this.$route.params.template], this.model).then(function() {

				this.original = this.$util.clone(this.model)

				this.clearStash()

				this.$router.push({
					name: 'Templates'
				})

			}.bind(this))

		},

		onDeleteClick: async function() {

			this.is.deleting = true

		},

		onConfirmDeleteClick: function() {

			this.is.confirming = true

			this.$api.delete(['template', this.$route.params.template]).then(function() {

				this.clearStash()

				this.$router.push({
					name: 'Templates'
				})

			}.bind(this))

		},

		onCancelDeleteClick: function() {

			this.is.deleting = false

		},

		onCopyClick: function() {

			this.is.copying = true

			this.replace = this.model.id

			var model = this.$util.clone(this.model)

			model.id = 0
			model.name = model.name + ' Copy'

			this.$api.post(['template', this.$route.params.template], model).then(function() {

				this.clearStash()

				this.$router.push({
					name: 'Templates'
				})

			}.bind(this))

		}

    }
    
}

</script>

<style scoped>

.delete {
	position: fixed;
	left: 664px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #f25151;
	background-color: #fff;
    z-index: 1000;
    box-shadow: inset 10px 0 15px -3px rgba(0, 0, 0, .1);
}

.delete.is-loading {
	pointer-events: none;
}

.delete-icon {
	font-size: 96px;
}

.delete-title {
	font-size: 24px;
	font-weight: 400;
	padding: 20px 0px;
}

.delete-text {
	font-size: 16px;
	line-height: 20px;
	padding: 0px 100px;
	text-align: center;
	color: #333;
	font-weight: 300;
}

.delete-buttons {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.delete-buttons-item {
	width: 150px;
	height: 40px;
	border: 2px solid #ccc;
	line-height: 36px;
	text-align: center;
	border-radius: 16px;
	color: #333;
	margin: 0px 10px;
	font-size: 16px;
	cursor: pointer;
}

.delete-buttons-item.is-danger {
	color: #fff;
	font-weight: 400;
	border-color: #f25151;
	background-color: #f25151;
}

</style>
